import {
  RecoverMerchantProfileSchema,
  RecoverMissingMerchantField,
  RecoverPhoneNumberProvisioningStatus,
  type RecoverMissingMerchantField as RecoverMissingMerchantFieldType,
} from "@redotech/redo-onboarding-api/schema/recover/recover-config";
import * as z from "zod/v4";

export const ConciergePhoneReadinessSchema = z.object({
  provisioningStatus: RecoverPhoneNumberProvisioningStatus,
  phoneNumber: z.string().nullish(),
  phoneNumberLastError: z.string().nullish(),
  missingMerchantFields: z.array(RecoverMissingMerchantField),
  merchantProfile: RecoverMerchantProfileSchema,
});

export type ConciergePhoneReadiness = z.infer<
  typeof ConciergePhoneReadinessSchema
>;

export type ConciergePhoneStatus =
  ConciergePhoneReadiness["provisioningStatus"];

export type ConciergeMissingMerchantField = RecoverMissingMerchantFieldType;

export const getConciergePhoneReadiness = {
  name: "getConciergePhoneReadiness" as const,
  input: z.object({}),
  output: ConciergePhoneReadinessSchema,
};
